export type ABTestMode = 'A' | 'B';

// Ключ для sessionStorage
const QUESTIONS_STORAGE_KEY = 'plinus_suggested_questions';

export interface ABTestSettings {
  mode: ABTestMode;
  isForced: boolean;
}

export interface SuggestedQuestions {
  questions: string[];
  originalRequest: string;
  expert?: string;
  person?: string;
  customExpert?: string;
  customPerson?: string;
}

/**
 * Получает режим A/B теста для пользователя
 */
export function getABTestMode(): ABTestMode {
  // Всегда возвращаем режим B
  return 'B';
}



/**
 * Получает текущие настройки A/B теста
 */
export function getABTestSettings(): ABTestSettings {
  // Всегда возвращаем режим B без принудительной установки
  return { mode: 'B', isForced: false };
}

/**
 * Сохраняет предложенные вопросы в sessionStorage
 */
export function saveSuggestedQuestions(data: SuggestedQuestions): void {
  sessionStorage.setItem(QUESTIONS_STORAGE_KEY, JSON.stringify(data));
}

/**
 * Получает сохраненные предложенные вопросы
 */
export function getSuggestedQuestions(): SuggestedQuestions | null {
  const data = sessionStorage.getItem(QUESTIONS_STORAGE_KEY);
  
  if (!data) return null;
  
  try {
    const parsed = JSON.parse(data);
    return parsed;
  } catch {
    return null;
  }
}

/**
 * Очищает сохраненные предложенные вопросы
 */
export function clearSuggestedQuestions(): void {
  sessionStorage.removeItem(QUESTIONS_STORAGE_KEY);
}

/**
 * Проверяет, есть ли сохраненные предложенные вопросы
 */
export function hasSuggestedQuestions(): boolean {
  return sessionStorage.getItem(QUESTIONS_STORAGE_KEY) !== null;
}
